import axios from 'axios';
import store from '../store';
import { Group } from '../models/Group';
import { UserMgmt } from '../models/UserMgmt';
import { ActiveFor } from '../utils/UserExpiry';
import {
  reactivateBody,
  userActionPath,
  userUpsertPayload,
} from '../utils/UserMgmtApi';
import { DeviceMgmt } from '../models/DeviceMgmt';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

let token = '';

export default {
  getGroups() {
    token = store.getters.token;
    return apiClient.get('/admin/group', {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  postGroup(group: Group) {
    token = store.getters.token;
    return apiClient.post('/admin/group', group, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  deleteGroup(groupId: number) {
    token = store.getters.token;
    return apiClient.delete('/admin/group/' + groupId, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  getAgms(groupId: number) {
    token = store.getters.token;
    return apiClient.get('/admin/apexagm/' + groupId, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  addAgm(agm: DeviceMgmt) {
    token = store.getters.token;
    return apiClient.post('/admin/apexagm/add', agm, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  deleteAgm(uid: number) {
    token = store.getters.token;
    return apiClient.delete('/admin/apexagm/' + uid, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  getUsers(groupId: number) {
    token = store.getters.token;
    return apiClient.get('/admin/user/' + groupId, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  /** EN-1883: activeFor only when the admin picked a period. */
  postUser(user: UserMgmt, activeFor?: ActiveFor) {
    token = store.getters.token;
    return apiClient.post('/admin/user', userUpsertPayload(user, activeFor), {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  deleteUser(userId: string) {
    token = store.getters.token;
    return apiClient.delete('/admin/user/' + userId, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  regenerateTemporaryPassword(userId: string) {
    token = store.getters.token;
    return apiClient.post(
      '/admin/user/' + userId + '/temporary-password',
      null,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },
  // EN-1883: deactivate / reactivate / extend; each returns the updated user.
  deactivate(userId: string) {
    token = store.getters.token;
    return apiClient.post(
      userActionPath('/admin/user', userId, 'deactivate'),
      undefined,
      { headers: { Authorization: `Bearer ${token}` } }
    );
  },
  reactivate(userId: string, activeFor?: ActiveFor) {
    token = store.getters.token;
    return apiClient.post(
      userActionPath('/admin/user', userId, 'reactivate'),
      reactivateBody(activeFor),
      { headers: { Authorization: `Bearer ${token}` } }
    );
  },
  extend(userId: string, activeFor: ActiveFor) {
    token = store.getters.token;
    return apiClient.post(
      userActionPath('/admin/user', userId, 'extend'),
      { activeFor },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  },
};
